/*
    Enable the ability of clear error input field by clicking the error indicator icon
*/
define('shared/initializer/form/adapters/mixins/HasRedemptionCodeUtil',[
    'shared/util/checkout/RedemptionCodeHelper'
], 
function (RedemptionCode) {
    'use strict';

    function Ctor() { }

    Ctor.prototype.doPageLoad = function( ) {
        var me = this;
        if (!me.redemptionCode) {
            me.redemptionCode = new RedemptionCode(me.options.useRedemptionCode);
        }
    };

    return Ctor;
});
